import makeStyles from "@material-ui/core/styles/makeStyles";
import { ShopApiFragment } from "@saleor/fragments/types/ShopApiFragment";
import { ShopApiProps } from "@saleor/types";
import { mapNodeToChoice } from "@saleor/utils/maps";
import React from "react";

import SingleSelectField from "../SingleSelectField";

const useStyles = makeStyles(
  theme => ({
    root: {
      "&& fieldset": {
        borderColor: theme.palette.divider
      },
      marginRight: theme.spacing(2),
      width: 192
    }
  }),
  {
    name: "AppShopApiSelect"
  }
);

export interface AppShopApiSelectProps extends ShopApiProps {
  shopApis: ShopApiFragment[];
  disabled: boolean;
  onShopApiSelect: (id: string) => void;
}

const AppShopApiSelect: React.FC<AppShopApiSelectProps> = ({
  shopApis,
  disabled,
  onShopApiSelect,
  selectedShopApiId
}) => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <SingleSelectField
        testId="app-ShopApi-select"
        choices={mapNodeToChoice(shopApis)}
        disabled={disabled}
        value={selectedShopApiId}
        onChange={event => onShopApiSelect(event.target.value)}
      />
    </div>
  );
};

AppShopApiSelect.displayName = "AppShopApiSelect";
export default AppShopApiSelect;
